import {combineReducers} from 'redux';
import app from "../containers/App/reducer";
import notification from "./enhancers/notification";
import magnet from "../containers/Magnet/reducer";
import magnetVendorsAccounts from "../containers/MagnetAccountsVendors/reducer";
import magnetSalesAccounts from "../containers/MagnetAccountsSales/reducer";
import magnetVendorsDecide from "../containers/MagnetDecideVendors/reducer";
import magnetSalesDecide from "../containers/MagnetDecideSales/reducer";
import magnetSalesBlacklist from "../containers/MagnetBlackListSales/reducer";
import magnetVendorsBlacklist from "../containers/MagnetBlackListVendors/reducer";
import magnetSalesContacts from "../containers/MagnetContactsSales/reducer";
import magnetVendorsContacts from "../containers/MagnetContactsVendors/reducer";

export const appReducer = combineReducers({
    app,
    notification,
    magnet,
    magnetVendorsAccounts,
    magnetSalesAccounts,
    magnetVendorsDecide,
    magnetSalesDecide,
    magnetSalesBlacklist,
    magnetVendorsBlacklist,
    magnetSalesContacts,
    magnetVendorsContacts,
});
